







import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "ConcatFooterButton",
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
});
